import { render } from "./CLOCommunicationPage.vue?vue&type=template&id=7ee6f2bc"
import script from "./CLOCommunicationPage.vue?vue&type=script&lang=js"
export * from "./CLOCommunicationPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__